export const voiceCalls = {
  "head": {
    "title": "Połączenia",
    "subtitle": "Połączenia odebrane przez recepcję telefoniczną."
  },
  "stats": {
    "all": "połączenie | połączenia | połączeń",
    "spoken": "odebrane | odebrane | odebranych",
    "inTotal": "łącznie"
  },
  "toolbar": {
    "searchLabel": "Szukaj",
    "searchPlaceholder": "Numer telefonu dzwoniącego…",
    "clear": "Wyczyść wyszukiwanie",
    "showLabel": "Pokaż",
    "showAll": "Wszystkie połączenia",
    "showSpoken": "Tylko odebrane",
    "showRecorded": "Tylko nagrane"
  },
  "notice": {
    "noRecording": "Połączenia nie są nagrywane.",
    "noRecordingHow": "Włącz opcję „Nagrywaj połączenia” w ustawieniach recepcji telefonicznej, a od tej chwili będzie można ich tutaj odsłuchać i zamienić na tekst."
  },
  "empty": {
    "title": "Nikt jeszcze nie dzwonił",
    "text": "Gdy ktoś zadzwoni na numer recepcji, połączenie pojawi się tutaj wraz z informacją, kto dzwonił, jak długo trwała rozmowa i czego dotyczyła.",
    "filteredTitle": "Żadne połączenie nie pasuje do tego filtra",
    "filteredText": "Spróbuj wyczyścić wyszukiwanie lub filtry powyżej."
  },
  "item": {
    "notSpoken": "Bez rozmowy",
    "unknownCaller": "Numer zastrzeżony",
    "linkSent": "Wysłano link do rezerwacji",
    "play": "Odtwórz nagranie",
    "pause": "Wstrzymaj",
    "showTranscript": "Pokaż transkrypcję",
    "hideTranscript": "Ukryj transkrypcję",
    "transcribe": "Transkrybuj i podsumuj",
    "transcribing": "Transkrypcja…",
    "noRecordingShort": "To połączenie nie zostało nagrane",
    "viewReservation": "Zobacz rezerwację",
    "noSummary": "To połączenie nie ma podsumowania.",
    "copy": "Kopiuj numer",
    "copied": "Skopiowano"
  },
  "errors": {
    "load": "Nie udało się wczytać połączeń.",
    "play": "Nie udało się odtworzyć nagrania.",
    "transcribe": "Nie udało się zamówić transkrypcji."
  },
  "table": {
    "call": "Połączenie",
    "reservation": "Rezerwacja",
    "listing": "Obiekt",
    "summary": "Podsumowanie",
    "duration": "Czas trwania",
    "date": "Data"
  }
};
